import { gql } from 'react-apollo';

export const getMembersStatistics = gql`
  query getChurchGroupWeeklyMembersStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            members {
              total
              joined: joined_for_period
            }
          }
        }
      }
    }
  }
`;

export const getPointsEarnedStatistics = gql`
  query getChurchGroupWeeklyPointsEarnedStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            totalPointsEarned: total_points_earned {
              totalPointsEarned: total_points_earned
              delta
              distribution {
                intervalStart: interval_start
                totalPointsEarned: total_points_earned
              }
            }
          }
        }
      }
    }
  }
`;

export const getPrayingStatistics = gql`
  query getChurchWeeklyPrayingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            praying {
              timePrayed: time_prayed
              timePrayedDelta: time_prayed_delta
              timeDistribution: time_distribution {
                intervalStart: interval_start
                timePrayed: time_prayed
              }
            }
          }
        }
      }
    }
  }
`;

export const getFastingStatistics = gql`
  query getChurchGroupWeeklyFastingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            fasting {
              days
              full
              forMeal: for_meal
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getOvercomingStatistics = gql`
  query getChurchGroupWeeklyOvercomingStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            overcoming {
              days
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getGuestCardsActivitiesStatistics = gql`
  query getChurchGroupWeeklyGuestCardsActivitiesStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            guestCardActivities: guest_card_activities {
              guestsTotal: guests_total,
              guestsForPeriod: guests_for_period,
              iaksSubmitted: iaks_submitted,
              iaksSubmittedDelta: iaks_submitted_delta,
              iaksByTypeDistribution: iaks_by_type_distribution {
                iak {
                  name
                }
                count
              }
              iaksByDayDistribution: iaks_by_day_distribution {
                intervalStart: interval_start
                count
              }
            }
          }
        }
      }
    }
  }
`;

export const getGoalsAndAveragesStatistics = gql`
  query getChurchGroupWeeklyGoalsAndAveragesStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            goalsAndAverages: goals_and_averages {
              pointsAverage: points_average
              timePrayedAverage: time_prayed_average
              iaksAverage: iaks_average
              pointsGoalPercentage: points_goal_percentage
              timePrayedGoalPercentage: time_prayed_goal_percentage
              iaksGoalPercentage: iaks_goal_percentage
            }
          }
        }
      }
    }
  }
`;

export const getGroupPerformanceStatistics = gql`
  query getChurchGroupWeeklyGroupPerformanceStatistics($churchId: Int!, $churchGroupId: Int!, $periodStartTime: DateTime!, $periodEndTime: DateTime!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          weekly(period_start_time: $periodStartTime, period_end_time: $periodEndTime) {
            groupPerformance: group_performance {
              position
              topPerformers: top_performers {
                position
                members {
                  id
                  name
                  photo {
                    small
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/weekly/queries/queries.js